import React from 'react';
import Routes from "./routes";
import i18n from "./i18n";
import Cookies from "js-cookie";
import MessageComponent from "./modules/common/components/MessageComponent/Message.component";

const App = () => {
  const app = document.getElementById('app');
  const appLocale = app && app.dataset && app.dataset.locale ? app.dataset.locale : null;
  const locale = appLocale || Cookies.get("locale") || 'en';
  i18n.changeLanguage(locale);
  return (
    <div>
      <MessageComponent />
      <Routes />
    </div>
  );
};

export default App;
